import React, { useMemo } from 'react';
import { Typography } from 'antd';
import { SPECIES_DISPLAY_LABELS } from '../../utils/herdTagLabels';
import { useSpeciesLifecycleOptional } from './SpeciesLifecycleContext';

const { Text } = Typography;

/**
 * Bullet list of lifecycle tag names per species (for help panels, docs in UI).
 */
export default function SpeciesLifecycleCatalogList({
  as = 'ul',
  speciesSlugs: slugsProp,
  className,
}) {
  const lifecycle = useSpeciesLifecycleOptional();
  const speciesSlugs = slugsProp ?? lifecycle?.speciesSlugs ?? [];

  const lines = useMemo(() => {
    if (!lifecycle?.isReady) return [];
    return speciesSlugs
      .map((slug) => {
        const tiers = lifecycle.listTierNamesForSpecies(slug);
        if (!tiers.length) return null;
        const label = SPECIES_DISPLAY_LABELS[slug] || slug.charAt(0).toUpperCase() + slug.slice(1);
        return { key: slug, text: `${label}: ${tiers.map((t) => t.name).join(', ')}` };
      })
      .filter(Boolean);
  }, [lifecycle, speciesSlugs]);

  if (!lifecycle?.isReady) {
    return <Text type="secondary" className={className}>Loading lifecycle names…</Text>;
  }

  if (!lines.length) return null;

  if (as === 'text') {
    return (
      <Text style={{ fontSize: 13 }}>
        {lines.map((l) => l.text).join(' · ')}
      </Text>
    );
  }

  const ListTag = as;
  const listClassName = ['tm-lifecycle-catalog-list', className].filter(Boolean).join(' ');

  return (
    <ListTag className={listClassName}>
      {lines.map((line) => {
        const colon = line.text.indexOf(': ');
        const speciesLabel = colon >= 0 ? line.text.slice(0, colon) : line.text;
        const tiers = colon >= 0 ? line.text.slice(colon + 2) : '';
        return (
          <li key={line.key} className="tm-lifecycle-catalog-item">
            <Text strong className="tm-lifecycle-catalog-species">
              {speciesLabel}
            </Text>
            {tiers ? (
              <Text type="secondary" className="tm-lifecycle-catalog-tiers">
                {tiers}
              </Text>
            ) : null}
          </li>
        );
      })}
    </ListTag>
  );
}
